import FooterBottom from './FooterBottom.vue'
export default FooterBottom


// WEBPACK FOOTER //
// ./src/components/FooterBottom/index.js